import { Field } from "@components/common/Field";
import { Agency } from "@gen/agency/v1/agency_pb";
import { Checkbox, Tag } from "@thetreep/ui";
import { formatDate } from "@utils/formatDate";

export const fields: (t: (s: string) => string) => Field<Agency>[] = (t) => [
  {
    key: "isEnabled",
    type: "text",
    label: t("status"),
    display: (value) => {
      const isEnabled = value as boolean;

      if (isEnabled) {
        return (
          <Tag size="small" bg="#DAFDEBCC" color="#218C26" text={t("active")} />
        );
      } else {
        return (
          <Tag
            size="small"
            bg="#E8ECEFCC"
            color="#536471"
            text={t("inactive")}
          />
        );
      }
    },
  },
  {
    key: "alias",
    type: "text",
    label: t("name"),
  },
  {
    key: "createdAt",
    type: "text",
    label: t("creationDate"),
    display: (value) => {
      const date = value as string;
      return date ? formatDate(date) : "";
    },
  },
  {
    key: "instanceUrl",
    type: "text",
    label: t("instanceUrl"),
  },
  {
    key: "caissesNames",
    type: "text",
    label: t("associatedCaisses"),
    display: (value) => {
      const caissesNames = value as string[];
      return caissesNames.join(", ");
    },
  },
  {
    key: "isTreepRecapEnabled",
    type: "text",
    label: t("treepRecap"),
    display: (value) => {
      const isEnabled = !!value;
      return <Checkbox checkmarkType="toggle" checked={isEnabled} disabled />;
    },
  },
  {
    key: "contactEmail",
    type: "text",
    label: t("contactEmail"),
  },
  {
    key: "billingClientName",
    type: "text",
    label: t("billingClientName"),
  },
  {
    key: "treepRecapPhoneNumber",
    type: "text",
    label: t("treepRecapPhoneNumber"),
  },
  {
    key: "logo",
    type: "text",
    label: t("logo"),
    display: (value) => {
      const srcLogo = value as string;
      return <img src={srcLogo} className="max-w-[120px] max-h-[80px]" />;
    },
  },
];
